import { apiClient } from './client.js'

export async function listRoomScans(params = {}) {
  const { data } = await apiClient.get('/room-scans', { params })
  return data?.scans ?? []
}

export async function fetchRoomScan(id) {
  const { data } = await apiClient.get(`/room-scans/${id}`)
  return data
}

export async function patchRoomScan(id, patch) {
  const { data } = await apiClient.patch(`/room-scans/${id}`, patch)
  return data
}

export async function deleteRoomScan(id) {
  const { data } = await apiClient.delete(`/room-scans/${id}`)
  return data
}
